import { render } from "./DonationMapSection.vue?vue&type=template&id=63b62a99"
import script from "./DonationMapSection.vue?vue&type=script&lang=js"
export * from "./DonationMapSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__